import { render, staticRenderFns } from "./GeojsonLayer.vue?vue&type=template&id=18bc68a8&scoped=true"
import script from "./GeojsonLayer.vue?vue&type=script&lang=js"
export * from "./GeojsonLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bc68a8",
  null
  
)

export default component.exports